import * as React from 'react';
import MyInvoicesView from '../layouts/MyInvoicesView';
import { MyInvoicesData } from 'src/reducers/paidinvoice';

export interface MyInvoicesPageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  myInvoicesData: MyInvoicesData[];
  dateFilter: (filterStartdate: Date, filterEnddate: Date) => void;
  dateReset: (filterStartdate: Date, filterEnddate: Date) => void;
  printTxn: (txn: String, type: String) => void;
}

class MyInvoicesPage extends React.Component<MyInvoicesPageProps> {
  render() {
    return (
      <div>
        <MyInvoicesView
          myInvoicesData={this.props.myInvoicesData}
          dateFilter={this.props.dateFilter}
          dateReset={this.props.dateReset}
          printTxn={this.props.printTxn}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default MyInvoicesPage;



// WEBPACK FOOTER //
// ./src/components/MyInvoices/MyInvoicesPage.tsx